import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import "../../styles/vendor/react-checkbox-tree.css";
import { Link } from "react-router-dom";
import { baseValue } from "../../libs/utils";
import BasicSelect from "./fields/BasicSelect";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { getOccupations } from "../../services/api/occupations";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      occupations: []
    };

    this._loadOccupations = this._loadOccupations.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    profile: PropTypes.object,
    setValues: PropTypes.func,
    isCreating: PropTypes.bool,
    setFieldValue: PropTypes.func,
    groups: PropTypes.array,
    "groups.map": PropTypes.func
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentProps = this.props;

    if (currentProps.profile !== nextProps.profile) {
      const profile = baseValue(nextProps.profile, {});

      currentProps.setValues({
        name: baseValue(profile.name),
        id: baseValue(profile.id),
        profileGroupId: baseValue(profile.profileGroupId)
      });
    }

    if (currentProps.isCreating && !nextProps.isCreating) {
      currentProps.resetForm();
      this.setState({ occupations: [] });
    }
  }

  _loadOccupations(value) {
    getOccupations({ "filter[name]": value }).then(value =>
      this.setState({ occupations: value.data })
    );
  }

  render() {
    const props = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />
          <BasicInput {...props} name="name" type="text" label="Name" />

          <BasicSelect
            {...props}
            name="profileGroupId"
            label="Profile Group"
            placeholder="Choose a Profile Group"
            options={this.props.groups.map(group => {
              return {
                value: group.id,
                title: group.name
              };
            })}
          />

          <div className="form-group m-form__group">
            <label>Functions</label>
            <AsyncTypeahead
              multiple={true}
              options={this.state.occupations}
              isLoading={false}
              placeholder={"Search ..."}
              minLength={2}
              labelKey="name"
              onSearch={this._loadOccupations}
              onChange={values =>
                this.props.setFieldValue(
                  "occupations",
                  values.map(value => value.id)
                )
              }
            />
          </div>
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                key="1"
                className={
                  "btn m-btn btn-primary" +
                  (props.isSubmitting
                    ? " m-btn--custom m-loader m-loader--light m-loader--left"
                    : "")
                }
                disabled={props.isSubmitting}
              >
                {props.profile ? "Update" : "Create"}
              </button>

              {props.profile && (
                <span key="2" className="m--margin-left-10">
                  or{" "}
                  <Link
                    to="/admin/profile-groups"
                    className="m-link m--font-bold"
                  >
                    Cancel
                  </Link>
                </span>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const ProfileForm = withFormik({
  mapPropsToValues: props => {
    const profile = baseValue(props.profile, {});

    return {
      name: baseValue(profile.name),
      id: baseValue(profile.id),
      profileGroupId: baseValue(profile.profileGroupId),
      occupations: [],
      redirect: false
    };
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    if (!values.profileGroupId || values.profileGroupId === "") {
      errors.profileGroupId = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default ProfileForm;
